const handleNavRoutings = () => {
  const navRouting = [
    {
      title: "Watch Videos",
      link: "/app",
      display: true,
    },
    // {
    //   title: "All Categories",
    //   link: "/category",
    //   display: true,
    // },
    {
      title: "Team and Culture",
      link: "/team",
      display: true,
    },
    {
      title: "Blogs",
      link: "/blog",
      display: true,
    },
  ];

  return navRouting;
};

export { handleNavRoutings };
